var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwitchOrientation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9067 3.36C26.2667 5.42667 29.3867 9.65333 29.8667 14.6667H31.8667C31.1867 6.45333 24.32 0 15.9333 0L15.0533 0.04L20.1333 5.12L21.9067 3.36ZM13.5733 2.33333C12.7867 1.54667 11.52 1.54667 10.7467 2.33333L2.26667 10.8133C1.48 11.6 1.48 12.8667 2.26667 13.64L18.2933 29.6667C19.08 30.4533 20.3467 30.4533 21.12 29.6667L29.6 21.1867C30.3867 20.4 30.3867 19.1333 29.6 18.36L13.5733 2.33333ZM19.7067 28.2533L3.68 12.2267L12.16 3.74667L28.1867 19.7733L19.7067 28.2533ZM9.96 28.64C5.6 26.5867 2.48 22.3467 2 17.3333H0C0.68 25.5467 7.54667 32 15.9333 32L16.8133 31.96L11.7333 26.88L9.96 28.64Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOrientation);
export default __webpack_public_path__ + "static/media/switch-orientation.361c78580daf94a218c0ee7ae50cd5f0.svg";
export { ForwardRef as ReactComponent };